import type { OnboardingProgress } from "./onboarding-progress";

export function policyIdentifier(progress: OnboardingProgress): string {
  if (!progress.policyName) return "my player";

  return progress.policyVersion === null
    ? progress.policyName
    : `${progress.policyName}:v${progress.policyVersion}`;
}

export function shortId(id: string): string {
  const [prefix, rest] = id.includes("_") ? id.split("_", 2) : [null, id];
  const head = (rest ?? "").slice(0, 8);
  return prefix ? `${prefix}_${head}` : head;
}

export function artifactLine(progress: OnboardingProgress): string | null {
  const artifact = progress.policyArtifact;

  if (!artifact) return null;

  if (artifact.files > 0) {
    const size =
      artifact.sizeBytes === null
        ? null
        : `${Math.max(1, Math.round(artifact.sizeBytes / 1024))} KB`;
    const files = `${artifact.files} file${artifact.files === 1 ? "" : "s"}`;
    return size ? `${files} · ${size}` : files;
  }

  return artifact.kind === null ? null : "container image";
}

export function requestSentence({
  progress,
  leagueName,
}: Readonly<{
  progress: OnboardingProgress;
  leagueName: string;
}>): string {
  return `Request an experience batch for ${policyIdentifier(progress)} in ${leagueName}`;
}

export function submitSentence({
  progress,
  leagueName,
}: Readonly<{
  progress: OnboardingProgress;
  leagueName: string;
}>): string {
  return `Submit ${policyIdentifier(progress)} to ${leagueName}`;
}
